import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'
import { ATTRIBUTES_FRAGMENT } from '../fragments/attributes'

export const EVENT_ATTRIBUTES_TYPES = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${ATTRIBUTES_FRAGMENT}

  query eventAttributesTypes {
    fetchEventTypes {
      ...Attributes
    }
    fetchEventAttributes {
      ...Attributes
    }
  }
`
